module.exports = "<p>\r\n  building-details works!\r\n</p>\r\n"